/**
 * @Author: Zewei
 * @Date:   2018-01-29T10:00:02+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-01-31T18:44:09+08:00
 */

import keyMirror from "keymirror";

export const DepartmentStructure = {
  ActionTypes: keyMirror({
    FETCHDATA: null,
    FETCHSUCCESS: null,
    FETCHFAILURE: null,
    CREATESUCCESS: null,
    CREATEFAILURE: null,
    UPDATESUCCESS: null,
    UPDATEFAILURE: null,
    DELETESUCCESS: null,
    DELETEFAILURE: null,
    // HIDDENMODAL: null,

    // department duty
    FETCHDUTYCATEGORYLISTSUCCESS: null,
    CLOSEDUTYCATEGORYMODAL: null,
    NEWDUTYCATEGORYSUCCESS: null,
    ADDDUTYCATEGORYSUCCESS: null,
    SAVEDUTYCATEGORYSUCCESS: null,
    DELETEDUTYCATEGORYSUCCESS: null,
    CHANGEDUTYNAME: null,

    FETCHDUTYLEVELSUCCESS: null,
    CLOSEDUTYLEVELMODAL: null,
    NEWDUTYLEVEL: null,
    CHANGEDUTYLEVELCHILD: null,
    CHANGEDUTYLEVEL: null,
    ADDDUTYLEVELSUCCESS: null,
    UPDATEDUTYLEVELSUCCESS: null,
    DELETEDUTYLEVELSUCCESS: null,

    INITDUTYSUCCESS: null,
    CLOSEDUTYMODAL: null,
    ADDDUTYSUCCESS: null,
    UPDATEDUTYSUCCESS: null,
    FETCHDEPARTMENTDUTYLISTSUCCESS: null,

    // position
    FETCHDEPARTMENTPOSITIONLISTSUCCESS: null,
    INITPOSITIONSUCCESS: null,
    UPDATEPOSITIONSUCCESS: null,
    INITMOVEPOSITIONSUCCESS: null,
    CREATENEWDEPARTMENTEXSUCCESS: null,
    UPDATEDEPARTMENTINITSUCCESS: null,
  })
};



// WEBPACK FOOTER //
// ./src/constants/department-structure-constants.js